(() => {
  const galleries = document.querySelectorAll('[data-rr-product-gallery]');

  galleries.forEach((gallery) => {
    if (gallery.dataset.rrGalleryInitialized === 'true') return;
    gallery.dataset.rrGalleryInitialized = 'true';

    const slides = [...gallery.querySelectorAll('[data-rr-gallery-slide]')];
    const thumbnails = [...gallery.querySelectorAll('[data-rr-gallery-thumbnail]')];
    const lightboxSlides = [...gallery.querySelectorAll('[data-rr-gallery-lightbox-slide]')];
    const dialog = gallery.querySelector('[data-rr-gallery-dialog]');
    const main = gallery.querySelector('[data-rr-gallery-main]');
    let currentIndex = 0;

    const showImage = (requestedIndex) => {
      if (!slides.length) return;

      currentIndex = (requestedIndex + slides.length) % slides.length;

      slides.forEach((slide, index) => {
        slide.hidden = index !== currentIndex;
      });

      lightboxSlides.forEach((slide, index) => {
        slide.hidden = index !== currentIndex;
      });

      thumbnails.forEach((thumbnail, index) => {
        const isSelected = index === currentIndex;
        thumbnail.setAttribute('aria-selected', String(isSelected));
        thumbnail.tabIndex = isSelected ? 0 : -1;
      });
    };

    const enableTouchSwipe = (surface, suppressClickAfterSwipe = false) => {
      if (!surface || slides.length <= 1) return;

      const minimumSwipeDistance = 48;
      let touchStart = null;
      let suppressClicksUntil = 0;

      surface.addEventListener(
        'touchstart',
        (event) => {
          if (event.touches.length !== 1) {
            touchStart = null;
            return;
          }

          const touch = event.touches[0];
          touchStart = { x: touch.clientX, y: touch.clientY };
        },
        { passive: true },
      );

      surface.addEventListener(
        'touchend',
        (event) => {
          const touch = event.changedTouches[0];
          if (!touchStart || !touch) return;

          const deltaX = touch.clientX - touchStart.x;
          const deltaY = touch.clientY - touchStart.y;
          touchStart = null;

          if (Math.abs(deltaX) < minimumSwipeDistance || Math.abs(deltaX) <= Math.abs(deltaY)) return;

          suppressClicksUntil = performance.now() + 500;
          showImage(currentIndex + (deltaX < 0 ? 1 : -1));
        },
        { passive: true },
      );

      surface.addEventListener(
        'touchcancel',
        () => {
          touchStart = null;
        },
        { passive: true },
      );

      if (suppressClickAfterSwipe) {
        surface.addEventListener(
          'click',
          (event) => {
            if (performance.now() > suppressClicksUntil) return;
            event.preventDefault();
            event.stopPropagation();
          },
          true,
        );
      }
    };

    const openLightbox = () => {
      if (!dialog || dialog.open === true) return;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    };

    const closeLightbox = () => {
      if (!dialog) return;
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    };

    gallery.querySelectorAll('[data-rr-gallery-open]').forEach((button) => {
      button.addEventListener('click', openLightbox);
    });

    gallery.querySelector('[data-rr-gallery-close]')?.addEventListener('click', closeLightbox);
    gallery.querySelector('[data-rr-gallery-prev]')?.addEventListener('click', () => showImage(currentIndex - 1));
    gallery.querySelector('[data-rr-gallery-next]')?.addEventListener('click', () => showImage(currentIndex + 1));

    dialog?.addEventListener('click', (event) => {
      if (event.target?.closest?.('button, .rr-product-gallery__lightbox-image')) return;
      closeLightbox();
    });

    dialog?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showImage(currentIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        showImage(currentIndex + 1);
      }
    });

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        showImage(Number(thumbnail.dataset.rrGalleryIndex));
      });

      thumbnail.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (currentIndex + direction + thumbnails.length) % thumbnails.length;
        showImage(nextIndex);
        thumbnails[nextIndex]?.focus();
      });
    });

    enableTouchSwipe(main, true);
    enableTouchSwipe(gallery.querySelector('.rr-product-gallery__dialog-content'), true);

    showImage(0);
  });
})();
